import React from 'react'

export function CalendarIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      fill="none"
      viewBox="0 0 24 24"
    >
      <path
        fill="#ffffff"
        fillRule="evenodd"
        d="M1.75 9.5a.75.75 0 01.75-.75h19a.75.75 0 01.75.75V20a1.75 1.75 0 01-1.75 1.75h-17A1.75 1.75 0 011.75 20V9.5zm1.5.75V20c0 .138.112.25.25.25h17a.25.25 0 00.25-.25v-9.75H3.25z"
        clipRule="evenodd"
      />
      <path
        fill="#ffffff"
        fillRule="evenodd"
        d="M3.5 4.25a.25.25 0 00-.25.25v4.25h17.5V4.5a.25.25 0 00-.25-.25h-17zm-1.75.25c0-.966.784-1.75 1.75-1.75h17c.966 0 1.75.784 1.75 1.75v5a.75.75 0 01-.75.75h-19a.75.75 0 01-.75-.75v-5z"
        clipRule="evenodd"
      />
      <path
        fill="#ffffff"
        fillRule="evenodd"
        d="M8 1.25a.75.75 0 01.75.75v4a.75.75 0 01-1.5 0V2A.75.75 0 018 1.25zM16 1.25a.75.75 0 01.75.75v4a.75.75 0 01-1.5 0V2a.75.75 0 01.75-.75zM13.25 17a.75.75 0 01.75-.75h3a.75.75 0 010 1.5h-3a.75.75 0 01-.75-.75zM6.25 17a.75.75 0 01.75-.75h3a.75.75 0 010 1.5H7a.75.75 0 01-.75-.75zM13.25 13a.75.75 0 01.75-.75h3a.75.75 0 010 1.5h-3a.75.75 0 01-.75-.75zM6.25 13a.75.75 0 01.75-.75h3a.75.75 0 010 1.5H7a.75.75 0 01-.75-.75z"
        clipRule="evenodd"
      />
    </svg>
  )
}
